import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Container = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    gap: 24px;
    height: 100%;
    justify-content: center;
    font-family: ${theme.v2.font.family.primary};
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      padding: 0 20px;
      width: auto;
    }
  `}
`;

export const ButtonsWrapper = styled.div`
  ${({ theme, $middleButton }) => css`
    background: ${theme.v2.colors.white.primary};
    border-top: 1px solid ${theme.v2.colors.brand.primaryLowLight};
    display: flex;
    justify-content: space-between;
    padding: 24px 56px;
    
    ${$middleButton && css`
      align-items: center;
      justify-content: center;
    `}

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: center;
      flex-direction: column-reverse;
      gap: 16px;
      padding: 16px;
    }
  `};
`;

export const ButtonContainer = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      max-width: 480px;
      width: 100%
    }
  `};
`;

export const Image = styled.img`
  ${({ theme }) => css`
    user-select: none;
    width: 448px;
    -webkit-user-drag: none;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      max-width: 40%;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `};
`;

export const Content = styled.div`
  ${({ $contentWidthFlexible, $centerContent, theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 8px;
    text-align: center;
    justify-content: ${$centerContent ? 'center' : 'flex-start'};
    width: ${!$contentWidthFlexible ? '685px' : '100%'};
    height: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      justify-conteont: flex-start;
    }    
  `};
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    align-item: center;
    color: ${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    gap: 8px;
    margin: 0;
  `}
`;

export const Subtitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryMedium};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0 0 20px;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    margin: 0;
    max-width: 690px;
  `}
`;
